import { createAction, props } from '@ngrx/store';

export const setConfGlobal = createAction(
  '[ConfGlobal] Set',
  props<{ confGlobal: any }>()
);

export const clearConfGlobal = createAction('[ConfGlobal] Clear');